import { useCallback, useRef, useEffect } from 'react';

interface IntersectionObserverInit {
    root?: Element | Document | null;
    rootMargin?: string;
    threshold?: number | number[];
}

type IntersectHandler = (_entry: IntersectionObserverEntry, _observer: IntersectionObserver) => void;

export default function useIntersect(onIntersect: IntersectHandler, options?: IntersectionObserverInit) {
    const ref = useRef<HTMLDivElement>(null);

    const callback = useCallback(
        (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    onIntersect(entry, observer);
                }
            });
        },
        [onIntersect],
    );

    useEffect(() => {
        if (!ref.current) return;
        const observer = new IntersectionObserver(callback, options);
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [ref, options, callback]);

    return ref;
}
